import Col from '../Col2.js';

const StatementInline = (props) => {

    return (
            <Col 
              {...props}
              className={` ${props.field.class} col-md-${props.field.width}`}
              key={props.objectkey} id={props.objectkey}>
                <span  dangerouslySetInnerHTML = {{ __html: props.field.fieldValue }}>
                </span>
            </Col> 
    );
}
export default StatementInline;